import { Component } from "@angular/core";
import {
  IonicPage,
  ModalController,
  ToastController,
  NavController,
  LoadingController,
} from "ionic-angular";

import {
  UserMyRadiant,
  WorkflowApproval,
  GlobalVarApproval,
} from "@providers/index";
import { ApiApproval } from "@providers/aproval_erp";
import { ListTaskPageApproval } from "..";

// @IonicPage()
@Component({
  selector: "page-list-master-aproval",
  templateUrl: "list-master.html",
})
export class ListMasterPage {
  page_title = "";
  listWorkflow = [];

  constructor(
    public navCtrl: NavController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public loadingCtrl: LoadingController,
    public workflow: WorkflowApproval,
    public globalvar: GlobalVarApproval,
    public userMyRadiant: UserMyRadiant,
    public approvalApi: ApiApproval
  ) {
    // approvalApi.modul_selected = userMyRadiant.approval_modul_selected;
    // userMyRadiant.approval_modul_selected;
    if (approvalApi.modul_selected == "spl") {
      this.page_title = "MyTask - SPL";
    } else if (approvalApi.modul_selected == "spc") {
      this.page_title = "MyTask - SPC";
    } else if (approvalApi.modul_selected == "rui") {
      this.page_title = "MyTask - RUI";
    } else if (approvalApi.modul_selected == "sdw") {
      this.page_title = "MyTask - SDW";
    }
  }

  doRefresh(refresher) {
    refresher.complete();
    this.get_data();
  }

  get_data() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = {
      User_ID: this.globalvar.app_user.user_attribute.id,
    };
    this.workflow.get(params).subscribe(
      (resp: any) => {
        this.listWorkflow = resp.data;
        loading.dismiss();
      },
      (err) => {
        loading.dismiss();
      }
    );
  }

  /**
   * The view loaded, let's query our items for the list
   */
  ionViewDidEnter() {
    this.get_data();
  }

  /**
   * Navigate to the detail page for this item.
   */
  selectWF(workflow) {
    /*if(!workflow.Workflow_Parent){
      let toast = this.toastCtrl.create({
        message: "Transaksi ini hanya dapat diproses melalui Web",
        duration: 3000,
        position: 'top'
      });
      toast.present();
      return;
    }*/
    this.navCtrl.push(ListTaskPageApproval, {
      workflow: workflow,
      is_mytask: 1,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/list-master/list-master.ts